export const DEVICE_TOKEN_IDENTIFIER = 'push.token';
export const DEVICE_TOKEN_IDENTIFIER_VOICE = 'push.token.voice';